// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"822":"5bc95f1d2908153763df","895":"ef055c4cf71b1233c40a"}[chunkId] + ".bundle.js";
};